// extracted by mini-css-extract-plugin
export default {"cls1":"TdRar_z19Oh5YXvYHOE8","cls2":"QA65xSH_F2aPmE_nGHc6 TdRar_z19Oh5YXvYHOE8"};